import customAxios from "../../customAxios";
import {FIND_STUDENT} from "../../routes";

type Props = {
  page?: number | string;
  limit?: number | string;
  academicYear?: string;
};

const findStudent = async (props: Props) => {
  var thisUrl = "";
  if (props?.page && props?.limit) thisUrl = `?page=${props.page}&limit=${props.limit}`;

  // ? academic year (سال تحصیلی) scope; the endpoint reads it from the query string or the body
  if (props?.academicYear) thisUrl += `${thisUrl ? "&" : "?"}academicYear=${props.academicYear}`;

  try {
    return (await customAxios.get(FIND_STUDENT + thisUrl)).data;
  } catch (error: any) {
    console.log({FIND_STUDENT: error});
  }
};

export default findStudent;
